import { Locale } from "@/Common/Models/Localization/Locale";

import LogoEnSvg from "@/Common/_images/logo-en.svg";
import LogoEsSvg from "@/Common/_images/logo-es.svg";
import LogoFrSvg from "@/Common/_images/logo-fr.svg";

interface IMyleLogoProps {
    locale: Locale;
    className?: string;
}

const logoMap = {
    [Locale.en]: LogoEnSvg,
    [Locale.fr]: LogoFrSvg,
    [Locale.es]: LogoEsSvg
};

function MyleLogo(props: Readonly<IMyleLogoProps>): JSX.Element {
    const Logo = logoMap[props.locale] || LogoEnSvg;
    return <Logo className={props.className} />;
}

export { MyleLogo };
